module.exports = __webpack_public_path__ + "static/img/cfpro_pay_help1.c9522f3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/cfpro_pay_help1.png
// module id = vdqn
// module chunks = 1